import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'

import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import CustomElement from 'designer/component/element/Element'

export const ElementSystem = (props) => (
  <DragElementWrapper {...props}>
    <CustomElement {...props} />
  </DragElementWrapper>
)

export const ElementDisplay = (props) => (
  <ElementWrapper {...props}>
    <CustomElement {...props} />
  </ElementWrapper>
)

export const elementTester = rankWith(1000, scopeEndsWith('element'))
